import { render, staticRenderFns } from "./TitleActions.vue?vue&type=template&id=6831cc88&"
import script from "./TitleActions.vue?vue&type=script&lang=ts&"
export * from "./TitleActions.vue?vue&type=script&lang=ts&"
import style0 from "./TitleActions.vue?vue&type=style&index=0&id=6831cc88&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports